import { fetchOperation } from "utils/api";

export const createPayfac = async (params) => {
  return await fetchOperation("/payfac", {
    ...params,
  });
};
